import { convertFromRaw } from 'draft-js';
import { stateFromHTML } from 'draft-js-import-html';


export function getProperContentForEditor(content){
    return typeof content === "object" ? convertFromRaw(content) : stateFromHTML(content);
}

export function getPlaceholder(mode, defaultValue){
    return mode === "EDIT_MODE" ? defaultValue : false
}


// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/DraftComponent/helpers.js